import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CheckCircle, AlertTriangle } from 'lucide-react';
export function TrustSection() {
  return <section className="py-10 px-4 bg-[#0a0514] relative overflow-hidden border-y border-[#27272a]" data-id="element-396">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-green-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-397" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-398">
        <div className="text-center mb-12" data-id="element-399">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-green-500/10 border border-green-500/20 text-green-400 text-sm font-bold mb-6" data-id="element-400">
            <ShieldCheck className="w-4 h-4" data-id="element-401" />
            COMPRA 100% SEGURA Y GARANTIZADA
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-5xl font-black text-white mb-6 leading-tight" data-id="element-402">
            ¿ES ESTO UNA ESTAFA? <br data-id="element-403" />
            <span className="text-green-500" data-id="element-404">ENTENDEMOS TU MIEDO.</span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-405">
            Sabemos que internet está lleno de promesas vacías. Por eso,
            queremos ser 100% transparentes con vos antes de que tomes cualquier
            decisión.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-406">
          {/* Trust Point 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#130a2a] border border-[#27272a] p-6 rounded-2xl" data-id="element-407">
            <div className="w-12 h-12 bg-green-500/10 rounded-xl flex items-center justify-center mb-4" data-id="element-408">
              <Lock className="w-6 h-6 text-green-500" data-id="element-409" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-410">
              Pago Protegido
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-411">
              Tu pago se procesa a través de plataformas líderes. Nosotros nunca
              vemos los datos de tu tarjeta. Tu inversión está protegida de
              principio a fin.
            </p>
          </motion.div>

          {/* Trust Point 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#130a2a] border border-[#27272a] p-6 rounded-2xl" data-id="element-412">
            <div className="w-12 h-12 bg-blue-500/10 rounded-xl flex items-center justify-center mb-4" data-id="element-413">
              <CheckCircle className="w-6 h-6 text-blue-500" data-id="element-414" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-415">
              Acceso Inmediato
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-416">
              Nada de esperar días. Una vez confirmado el pago, recibís el
              acceso a todo el material automáticamente en tu email. Sin
              vueltas.
            </p>
          </motion.div>

          {/* Trust Point 3 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#130a2a] border border-[#27272a] p-6 rounded-2xl" data-id="element-417">
            <div className="w-12 h-12 bg-yellow-500/10 rounded-xl flex items-center justify-center mb-4" data-id="element-418">
              <AlertTriangle className="w-6 h-6 text-yellow-500" data-id="element-419" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-420">Garantía Real</h3>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-421">
              Si el contenido no es lo que esperabas, tenés 7 días de garantía.
              No estamos acá para sacarte plata, estamos acá para que aprendas
              un oficio real.
            </p>
          </motion.div>

          {/* Trust Point 4 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#130a2a] border border-[#27272a] p-6 rounded-2xl" data-id="element-422">
            <div className="w-12 h-12 bg-purple-500/10 rounded-xl flex items-center justify-center mb-4" data-id="element-423">
              <ShieldCheck className="w-6 h-6 text-purple-500" data-id="element-424" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-425">
              Soporte Humano
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-426">
              Detrás de este curso hay personas reales. Si tenés algún problema
              con el acceso o el material, nuestro equipo te ayuda por Email.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="mt-12 p-6 bg-green-500/5 border border-green-500/20 rounded-2xl text-center" data-id="element-427">
          <p className="text-green-400 font-medium italic" data-id="element-428">
            "Mi reputación vale más que cualquier venta. Este curso es el
            resultado de años de trabajo y quiero que sea tu puerta de entrada a
            un negocio rentable."
          </p>
        </motion.div>
      </div>
    </section>;
}